import { type FetchResponse } from '@cian/http-api';
import { type IHttpApi } from '@cian/http-api/shared';
import { type ILogger } from '@cian/logger/shared';

import { type IComparisonAlbum } from '../../repositories/property-comparison/entities/v1_get_comparison_albums/ComparisonAlbum';
import { type IGetComparisonAlbumsResponse } from '../../repositories/property-comparison/entities/v1_get_comparison_albums/GetComparisonAlbumsResponse';
import { fetchGetComparisonAlbums } from '../../repositories/property-comparison/v1/get-comparison-albums';
import { type TGetComparisonAlbumsResponse } from '../../repositories/property-comparison/v1/get-comparison-albums/types';
import { UnknownError } from '@cian/peperrors';

const DOMAIN = 'src/shared/services/propertyComparison/getComparisonAlbums';
const DEGRADATION_MESSAGE = '[Degradation] Не удалось получить альбомы сравнения';

interface IGetComparisonAlbumsParams {
  httpApi: IHttpApi;
  logger: ILogger;
}

export async function getComparisonAlbums({
  httpApi,
  logger,
}: IGetComparisonAlbumsParams): Promise<IComparisonAlbum[] | null> {
  try {
    const { statusCode, response } = (await fetchGetComparisonAlbums({
      httpApi,
    })) as FetchResponse<TGetComparisonAlbumsResponse>;

    if (statusCode !== 200) {
      logger.error(DEGRADATION_MESSAGE, { domain: DOMAIN, statusCode });

      return null;
    }

    return (response as IGetComparisonAlbumsResponse).comparisonAlbums;
  } catch (error) {
    logger.error(DEGRADATION_MESSAGE, { domain: DOMAIN, error: error as UnknownError });

    return null;
  }
}
